export default __webpack_public_path__ + "static/media/hamburger-icon.2a7edea4.svg";